<template>
  <div class="container">
    <div class="text-start">
      <div class="d-flex justify-content-between align-items-end mb-3">
        <div>
          <h1 class="fw-bold">Achievements</h1>
        </div>
      </div>
      <div v-if="getMyMappedGroup">
        <AchievementScoreboard
          :myGroup="getMyMappedGroup"
          :myPoints="getMyTotalPoints"
        />
      </div>
      <div class="mb-5"></div>
      <div class="row g-4 align-items-stretch">
        <div
          v-for="achievement in filterAchievements"
          :key="achievement.id"
          class="col-md-4 d-flex flex-column"
        >
          <!-- Badge should stretch to same height -->
          <div class="flex-grow-1 d-flex">
            <div class="mb-3 w-100">
              <AchievementBadge :achievement="achievement" :showUsers="true" />
            </div>
          </div>

          <!-- Debug section stays below, outside equalized height -->
          <div class="mt-2" v-if="isDebugMode">
            <div v-for="code in achievement.codes" :key="code" class="text-end">
              <a
                :href="`/#/reward/${code}`"
                class="btn-link text-decoration-none"
              >
                <span>Reward {{ achievement.name }} ({{ code }}) </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AchievementBadge from "@/components/activity/AchievementBadge.vue";
import AchievementScoreboard from "@/components/activity/AchievementScoreboard.vue";

export default {
  name: "AchievementList",
  components: { AchievementBadge, AchievementScoreboard },
  data() {
    return {
      selectedAchievementFilter: ""
    };
  },
  props: {},
  computed: {
    getURL() {
      return `/sb-250-house-competition/#/reward/${this.code}`;
    },
    ...mapGetters(["isDebugMode"]),
    ...mapGetters("achievements", [
      "getMyAchievementsList",
      "getMyTotalPoints"
    ]),
    ...mapGetters("groups", ["getMyMappedGroup"]),
    // Filter out unapproved achievements unless it is earned by the user
    // This is how hidden achievements are implemented
    filterAchievements() {
      let achievements = this.getMyAchievementsList;

      let filtered = achievements.filter((achievement) => {
        if (achievement.status === "approved") {
          return true;
        } else if (
          achievement.status === "under review" &&
          achievement.isEarned
        ) {
          return true;
        }

        return false;
      });

      return filtered;
    }
  },
  methods: {
    setSelectedAchievementFilter(filter) {
      this.selectedAchievementFilter = filter;
    }
  }
  /* lifecycle hooks */
};
</script>
